



































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Work, Buhin } from "@/models/Buhin";
import { BuhinsService } from "@/services/Buhins.service.ts";
import Pagination from "@/views/components/Pagination.vue";
import InputString from "@/views/components/input/InputString.vue";
import ComponentWithGroupShaten from '@/views/components/ComponentWithGroupShaten';
import FilterSelectBox from '@/shared/mixins/FilterSelectBox';
import { CommonService } from '@/services/Common.service';
@Component({
  components: {
    InputString,
    Pagination
  },
  mixins: [FilterSelectBox]
})
export default class SeibiBuhinLink extends ComponentWithGroupShaten {
  @Prop({ default: "" })
  title: string;
  loading: boolean = false;
  buhinService = new BuhinsService();
  showEditDialog: boolean = false;
  seibiList: Work[] = [];
  seibiSelected: Work[] = [];
  saveSeibiSelected: Work[] = [];
  workFilter: any = {
    workCd: "",
    workNm: ""
  };
  buhinList: any = [];
  seibiPageList: any = [];
  listSelected: string[] = [];
  workEditing: any = {};

  bunruiSelectedList: any = [];
  activeBuhinShubetsuCd = "";

  public itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  public itemSizeSelected: number = 10;

  commonService = new CommonService();
  versionList: any = [];
  buhinLoading = false;
  importPtn: number = 0;
  importPtns: any = [];

  created() {
    this.form = {
      kyotenCd: "",
      groupCd: "",
      shatenCd: "",
      version: ""
    };
    this.form.kyotenCd = localStorage.getItem("kyotenCd");
    this.getGroupDataList().then(res => {
      this.getShatenDataList().then(res2 => {
        this.getKyotenDataList().then(res3 => {
          this.getVersionList().then(() => {
            if (this.versionList.length === 1) {
              this.form.version = this.versionList[0].sknHanyouSeibiVersionId;
              this.getSeibiList();
              this.getBuhinList();
            }
          });
        });
      });
    });
  }

  async getBuhinList() {
     let param = null;
    if (!this.form.version) {
      const { groupCd, shatenCd } = this.form;
      param = { groupCd, shatenCd };
    }
    this.buhinLoading = true;
    const response = await this.buhinService.getBuhins(this.form.version, param);
    this.buhinLoading = false;
    this.loading = false;
    if (response) {
      this.$set(this, "buhinList", [...response]);
    } else {
      this.$set(this, "buhinList", []);
    }
  }

  searchSeibiList() {
    this.getSeibiList();
  }

  public async getSeibiList() {
    this.loading = true;
    const response = await this.buhinService.getSeibi(
      this.form.version,
      this.workFilter.workCd,
      this.workFilter.workNm
    );
    this.loading = false;
    if (response) {
      const data = response.map((e: any) => {
        let isCheck: boolean = false;
        return {
          ...e,
          isCheck
        };
      });

      this.$set(this, "seibiList", data.reverse());
    } else {
      this.$set(this, "seibiList", []);
    }
  }

  onShowEditDialog(rowData: any) {
    this.showEditDialog = true;
    this.listSelected = [];
    this.workEditing = rowData;
    let hasBuin = false;
    if (rowData.buhins && rowData.buhins.length > 0) {
      this.listSelected = rowData.buhins.map((buhin: any) => buhin.buhinCd);
      hasBuin = true;
    }
    if (this.buhinList.length > 0) {
      if (hasBuin) {
        this.buhinList.forEach((shubetsu: any) => {
          shubetsu.items.forEach((bunrui: any) => {
            if (bunrui.items) {
              bunrui.items.forEach((buhin: any) => {
                if (this.listSelected[0] === buhin.buhinCd) {
                  this.activeBuhinShubetsuCd = shubetsu.buhinShubetsuCd;
                  this.bunruiSelectedList = [bunrui.buhinBunruiId];
                }
              });
            }
          });
        });
      } else {
        this.activeBuhinShubetsuCd = this.buhinList[0].buhinShubetsuCd;
      }
    }
  }

  getWorkName(rowData: any) {
    if (rowData.work) {
      const listWorkName = rowData.work.map((e: any) => e.workNm);
      return listWorkName.join("、");
    }
    return "";
  }

  onCloseDialog() {
    this.showEditDialog = false;
  }

  onSave() {
    this.showEditDialog = false;
    const workSave: any = {
      id: this.workEditing.id,
      workCd: this.workEditing.workCd
    };
    workSave.buhins = this.listSelected.map((e: string) => {
      return {
        buhinCd: e
      };
    });
    this.buhinService.saveBuhinLink(workSave, this.form.version).then((res: any) => {
      this.getSeibiList();
    });
  }

  deepCopy(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  }

  listBuhinName(work: any) {
    let listNm = [];
    if (work.buhins && work.buhins.length > 0) {
      listNm = work.buhins.map((buhin: any) => buhin.buhinNm);
    }
    return listNm.join("、");
  }

  isBunruiSelected(bunruiId: any) {
    return this.bunruiSelectedList.indexOf(bunruiId) > -1;
  }

  showBunrui(bunruiId: any) {
    if (this.bunruiSelectedList.length == 0) {
      return true;
    } else {
      return this.isBunruiSelected(bunruiId);
    }
  }

  onSelectShubetsu(tab: any, event: any) {
    this.bunruiSelectedList = [];
  }

  onSelectBunrui(bunruiId: number) {
    const findIndex = this.bunruiSelectedList.indexOf(bunruiId);
    if (findIndex === -1) {
      this.bunruiSelectedList.push(bunruiId);
    } else {
      this.bunruiSelectedList.splice(findIndex, 1);
    }
  }

  async selectGroup1() {
    this.versionList = [];
    this.selectGroup();
  }

  async getVersionList() {
    const res = await this.commonService.getHanyouSeibiVersion(
      this.form.groupCd,
      this.form.shatenCd,
      this.form.kyotenCd
    );
    this.$set(this, "versionList", res);
  }

  selectKyoten() {
    this.getVersionList();
  }

  selectVersion() {
    this.getBuhinList();
    this.getSeibiList();
  }

  async getKyotenDataList() {
    this.form.version = "";
    this.versionList = [];
    const response = await this.commonService.getKyotenHasVersion(
      this.form.groupCd,
      this.form.shatenCd
    );
    if (response) {
      this.$set(this, "kyotenDataList", response);
    }
    if (this.kyotenDataList.length === 0) {
      this.form.kyotenCd = "";
      this.getVersionList();
    }
    return response;
  }
}
